import { useEffect, useSyncExternalStore } from 'react';
import {
  getDymoSnapshot,
  refreshDymoStatus,
  subscribeDymo,
  type DymoSnapshot,
} from './dymo-browser.js';

/**
 * The shared DYMO status (dymo-browser.ts) as a hook.
 *
 * `check` says whether this component wants the printer looked for when it
 * mounts. It is a parameter, not a default, because the look itself is visible:
 * the first time a page reaches for software on the computer, Chromium asks the
 * user to allow it. So the Labeling page checks only when this browser's
 * destination IS the DYMO printer, and the settings page — where the printer is
 * chosen — always does. A browser that never chose the DYMO printer is never
 * asked anything.
 */
export function useDymoStatus(check: boolean): DymoSnapshot {
  const snapshot = useSyncExternalStore(subscribeDymo, getDymoSnapshot);
  useEffect(() => {
    if (check) void refreshDymoStatus();
  }, [check]);
  return snapshot;
}
